import { render, staticRenderFns } from "./ManageSchoolList.vue?vue&type=template&id=69939464&scoped=true"
import script from "./ManageSchoolList.vue?vue&type=script&lang=js"
export * from "./ManageSchoolList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69939464",
  null
  
)

export default component.exports